module.exports = __webpack_public_path__ + "static/media/gobimanchurian.c66a6094.jpg";